import { DataTable } from './DataTable'
import { Button } from 'antd'
import { YhBox } from '@/components/YhBox'
import { baseFleetModel } from '../fleetModel'
import { CarOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { setAddCarVisible } = baseFleetModel()

    const action = (
        <>
            <Button shape="round" type="primary" onClick={() => setAddCarVisible(true)}>
                <CarOutlined />
                添加车辆现场
            </Button>
            {/* <Button shape="round" onClick={() => {
        if(!selectedRowKeys.length){
            return message.warning('请选择车辆现场进行删除功能！')
        }else{
            onDelete(selectedRowKeys)}}}><DeleteOutlined />一键删除</Button> */}
        </>
    )

    return (
        <div>
            <YhBox title="" action={action} style={{ height: 'calc(100vh - 185px)' }}>
                <DataTable />
            </YhBox>
        </div>
    )
}
